import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientQuery, clientMutation } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";
import { ExceptionManager } from "Core/logManager"

const INIT_STATE = {
    loading: false,
    open: false,
    data: null,
    restart: false,
    erorrRoutes: null
};

const route = "settings/views/routes/components/modalMarkerRoute";

export const RoutesManagerModalMarkerRouteRedux = createSlice({
    name: route,
    initialState: INIT_STATE,
    reducers: {
        reset: (state, action) => {
            return action.payload
                ? { ...state, ...action.payload }
                : { ...INIT_STATE };
        },
        openModalMarkerRoute: (state, action) => {
            return {
                ...state,
                open: action.payload?.open,
                data: action.payload?.data || null
            }
        }
    }
})

const { actions, reducer } = RoutesManagerModalMarkerRouteRedux;

export const { reset, openModalMarkerRoute } = actions;

export default reducer;
